import { useSearchParams } from 'react-router-dom';
import { queryLetter } from '../configs';
import { useEffect } from 'react';
import { dlSearchEvent } from '../../events/search/dl.search.event';
import { useAlgoliaDataContext } from '../hooks/useAlgoliaDataContext';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../constants/searchParamKeys';
import { dlDispatchAmplEvent } from '../../events/dl.dispatchAmplEvent';
const searchForm = document.querySelector('search-form-component');
let prevQuery = '';
export const DLSearchEvent = () => {
    const [searchParams] = useSearchParams();
    const { queryID, nbHits } = useAlgoliaDataContext();
    useEffect(() => {
        const query = searchParams.get(queryLetter);
        const page = searchParams.get(SEARCH_PARAM_KEY_PAGE_NUMBER) ?? 1;
        if (queryID === undefined ||
            queryID.length < 1 ||
            prevQuery === query ||
            page > 1)
            return;
        window.dataLayer.push({
            page_context: {
                search_term: query ?? '',
                number_of_items: nbHits
            }
        });
        dlSearchEvent({
            query: query ?? '',
            nbHits
        });
        dlDispatchAmplEvent('search', {
            search_term: query ?? '',
            inputType: searchForm?.inputType,
            number_of_items: nbHits
        });
        prevQuery = query;
    }, [queryID]);
    return null;
};
